var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"animate-pulse pl-8"},_vm._l((5),function(n){return _c('div',{key:n,staticClass:"border-b border-gray-lightest w-full py-2.5 mb-3"},[_c('div',{staticClass:"h-4 rounded-md bg-gray-lightest w-full mb-3"}),_c('div',{staticClass:"h-4 rounded-md bg-gray-lightest w-full mb-3"})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }